import { SelectOption } from '@property.com.au/ui-kit';
import { mapSelectOptionWithIntValueToSelectOption } from '../app-kit/helpers/mapSelectOptionWithIntValueToSelectOption';
import { SearchPage_FilterOptions } from '../reducers/propertyConfigReducer';
import { SelectOptionWithBadge } from '../types';
import {
  SearchModalsFilterOptions,
  SearchOptionEcoFriendlyFeature,
  SearchOptionIndoorFeature,
  SearchOptionMinBedrooms,
  SearchOptionOutdoorFeature,
  SearchOptionPropertyStatus,
  SearchOptionPropertyType,
} from '../types';
import { SEARCH_SEPARATOR } from './defaults';

type ApiMultiSelectType =
  | SearchOptionPropertyType
  | SearchOptionIndoorFeature
  | SearchOptionOutdoorFeature
  | SearchOptionEcoFriendlyFeature;

type ApiOptionType = SearchOptionMinBedrooms;
export const mapApiMultiSelectToSelectOption = ({
  label,
  value,
}: ApiMultiSelectType): SelectOption => {
  return { label: label ?? '', value: value ?? '' };
};
export const mapApiOptionToSelectOption = ({ label, value }: ApiOptionType): SelectOption => {
  return { label: label ?? '', value: value ?? '' };
};

export const mapApiSearchOptionPropertyStatusToSelectOptionWithBadge = ({
  label,
  value,
  callout,
}: SearchOptionPropertyStatus): SelectOptionWithBadge => {
  return {
    label: label?.text ?? '',
    value: String(value),
    badge: label.variant,
    ...(callout ? { callout: { variant: callout.variant, text: callout.text } } : {}),
  };
};

export const mapApiFiltersOptionsToFilterOptions = (
  filterOptions: SearchModalsFilterOptions | null,
): SearchPage_FilterOptions => {
  return {
    propertyStatus:
      filterOptions?.propertyStatus?.map(mapApiSearchOptionPropertyStatusToSelectOptionWithBadge) ??
      [],
    propertyTypes: filterOptions?.propertyTypes?.map(mapApiMultiSelectToSelectOption) ?? [],
    minBedrooms: filterOptions?.minBedroomsV2?.map(mapApiOptionToSelectOption) ?? [],
    minBathrooms: filterOptions?.minBathrooms?.map(mapSelectOptionWithIntValueToSelectOption) ?? [],
    indoorFeatures: filterOptions?.indoorFeatures?.map(mapApiMultiSelectToSelectOption) ?? [],
    outdoorFeatures: filterOptions?.outdoorFeatures?.map(mapApiMultiSelectToSelectOption) ?? [],
    ecoFriendlyFeatures:
      filterOptions?.ecoFriendlyFeatures?.map(mapApiMultiSelectToSelectOption) ?? [],
    minCarSpaces: filterOptions?.minCarSpaces?.map(mapSelectOptionWithIntValueToSelectOption) ?? [],
  };
};

export const createSelectOption = ({
  label,
  value,
}: {
  label: string;
  value: string;
}): SelectOption => {
  return { label, value };
};

export const mapSelectOptionsToState = (
  options: SelectOption[],
  fallback: string = '',
  separator = SEARCH_SEPARATOR,
): string => {
  const formatted = options
    .map((option) => option.value)
    .filter(Boolean)
    .join(separator)
    .trim();

  return formatted.length > 0 ? formatted : fallback;
};
